import { Alert, Button, Col, Container, Row, Spinner } from "reactstrap";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Profile from "../playerInfo/componants/Profile";
import Performance from "../playerInfo/componants/Performance";
import Videos from "../playerInfo/componants/Videos";
import Historique from "../playerInfo/componants/Historique";
import Header from "../playerInfo/componants/Header";
import { getPlayerById } from "store/slices/agentPlayerSlice";
import AgentPlayerProfile from "./components/AgentPlayerProfile";
import AgentPlayerInfoHeader from "./components/AgentPlayerInfoHeader";
import AgentPlayerPerformance from "./components/AgentPlayerPerformance";
import AgentPlayerVideos from "./components/AgentPlayerVideo";
import AgentPlayerHistory from "./components/AgentPlayerHistory";

const AgentPlayerInfo = () => {
  const { id } = useParams();
  console.log("player id: ", id);
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { player, getProfileLoading, error } = useSelector(
    (state) => state.AgentPlayer
  );
  console.log("player: ", player);

  const [visibleCompanant, setVisibleCompanant] = useState("profile");

  useEffect(() => {
    dispatch(getPlayerById(id));
  }, []);

  useEffect(() => {
    player && console.log("player " + JSON.stringify(player, null, 2));
  }, [player]);

  if (getProfileLoading) return <Spinner />;
  if (error) return <Alert color="danger">{error.message}</Alert>;

  return (
    <div className="page-content">
      <Container fluid style={{ maxWidth: "100%" }}>
        <div className="page-title-box">
          <AgentPlayerInfoHeader />
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "15px",
              justifyContent: "flex-start",
              paddingLeft: "30px",
            }}
          >
            <Button
              style={{
                background: "white",
                border: "none",
                color: "black",
                cursor: "pointer",
                fontSize: "14px",
                ...(visibleCompanant === "profile" && { opacity: "50%" }),
              }}
              onClick={() => setVisibleCompanant("profile")}
            >
              {t("playerInfo.profileTab")}
            </Button>
            <Button
              style={{
                background: "white",
                border: "none",
                color: "black",
                cursor: "pointer",
                fontSize: "14px",
                ...(visibleCompanant === "performance" && { opacity: "50%" }),
              }}
              onClick={() => setVisibleCompanant("performance")}
            >
              {t("playerInfo.performanceTab")}
            </Button>
            <Button
              style={{
                background: "white",
                border: "none",
                color: "black",
                cursor: "pointer",
                fontSize: "14px",
                ...(visibleCompanant === "videos" && { opacity: "50%" }),
              }}
              onClick={() => setVisibleCompanant("videos")}
            >
              {t("playerInfo.videosTab")}
            </Button>
            <Button
              style={{
                background: "white",
                border: "none",
                color: "black",
                cursor: "pointer",
                fontSize: "14px",
                ...(visibleCompanant === "historique" && { opacity: "50%" }),
              }}
              onClick={() => setVisibleCompanant("historique")}
            >
              {t("playerInfo.historiqueTab")}
            </Button>
          </div>
          <hr
            style={{
              marginTop: "2px",
              borderColor: "EAEAEA",
              borderWidth: "2px",
            }}
          />
          {visibleCompanant === "profile" && <AgentPlayerProfile />}
          {visibleCompanant === "performance" && <AgentPlayerPerformance />}
          {visibleCompanant === "videos" && <AgentPlayerVideos />}
          {visibleCompanant === "historique" && <AgentPlayerHistory />}
        </div>
      </Container>
    </div>
  );
};

const styles = {
  titreInfo: {
    color: "#000000",
  },
  infoProfile: {
    marginBottom: "18px",
    fontSize: "18px",
    font: "Poppins",
  },

  statInfo: {
    marginBottom: "18px",
    fontSize: "16px",
    font: "Poppins",
  },
  listeItem: {
    marginBottom: 2,
  },
};

export default AgentPlayerInfo;
